import { RxApolloClient } from './RxApolloClient';
import { RxObservableQuery } from './RxObservableQuery';
import { rxify } from './rxify';
export { RxApolloClient, RxObservableQuery, rxify };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client-rxjs/index.js
// module id = 187
// module chunks = 4